import {
  getRecentReasons as getRecentReasonsAction,
  resetRecentReason as resetRecentReasonAction,
} from 'Redux/modules/patient/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useGetRecentReason = () => {
  const { requestReasons, status } = useSelector(state => state.patients);

  const dispatch = useDispatch();

  const getRecentReasons = useCallback(
    (patientId, clinicId) => {
      dispatch(getRecentReasonsAction(patientId, { limit: 2, clinicId }));
    },
    [dispatch],
  );
  const resetRecentReason = useCallback(() => {
    dispatch(resetRecentReasonAction());
  }, [dispatch]);

  return {
    requestReasons,
    loading: status.requestReasons === 0,
    getRecentReasons,
    resetRecentReason,
  };
};

export default useGetRecentReason;
